import axios from 'axios'

const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'http://13.94.137.142:3000/' // backend que levanta el main backend, en el mismo server que el propio front
    : 'http://localhost:3001/'

const startRequest = axios.create({
  baseURL
})

export default startRequest
